<template>
  <!-- the select2 styling here is generated via the select2 class to change
  the style of this element this is what needs to be changed. -->
  <div :id="parent" class="form-group">
    <select
      :id="parent + 'child'"
      class="form-control select2"
      style="color: black;"
    >
      <option :value="null" disabled hidden>{{ placeholder }}</option>
      <slot></slot>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "Select2",
  props: ["options", "value", "placeholder", "required", "parent"],
  mounted: function() {
    this.buildDropdown();
  },
  computed: {
    ...mapGetters(["isOldIE"])
  },
  watch: {
    value: function(value) {
      $(`#${this.parent}child`)
        .val(value)
        .trigger("change");
    },
    options: function(opt) {
      this.buildDropdown();
    },
    required: function() {
      this.buildDropdown();
    }
  },
  destroyed: function() {
    $(`#${this.parent}child`)
      .off()
      .select2("destroy");
  },
  methods: {
    buildDropdown: function() {
      var vm = this;
      var dropDownParent = $(`#${this.parent}`);
      var dropdown = $(`#${this.parent}child`);
      dropdown
        .select2({
          data: this.options,
          dropdownParent: dropDownParent
        })
        .val(this.value)
        .trigger("change")
        .on("change", function() {
          vm.$emit("input", this.value);
        })
        .prop("required", this.required);
      this.updateCustomValidity();
    },
    updateCustomValidity(message) {
      if (this.isOldIE) {
        return;
      }
      var dropdown = $(`#${this.parent}child`)[0];
      if (this.required) {
        dropdown.oninvalid = dropdown.setCustomValidity(
          "Please select at least a sector."
        );
      } else {
        dropdown.oninvalid = dropdown.setCustomValidity("");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/Select2Wrapper.vue